const riot = require('riot');

riot.tag2('page-workspace-settings', '<div class="f fclm h-full"> <div data-is="module-header" title="ワークスペース編集" back="{true}"></div> <div class="w-full px16 flex-auto overflow-hidden mb16"> <div class="f s-full border border-separator_opacity lh15 rounded-12 overflow-hidden"> <div class="max-width-248 w-full pt16 bg-background_light_secondary"> <div class="border-left border-label_dark_medium bw3 fs12 lh13 bold text-label_dark_medium pl8 my8">{workspace.data.name}</div> <div class="mb32"> <div class="py14 px16 cursor-pointer {tab.id === current ? \'bg-white bold border-bottom border-transparent\' : \'border-bottom\'}" each="{tab in app.data.settings.workspace.tabs}" onclick="{onChangeTab}"> <div>{tab.text}</div> </div> </div> </div> <div class="w-full bg-white overflow-y-scroll scrollbar-none py24"> <div class="max-width-576 w-full mxa"> <div if="{workspace}" data-is="module-workspace-{current}_" workspace="{workspace}" workspace_user="{workspaceUser}"></div> </div> </div> </div> </div> </div>', 'page-workspace-settings,[data-is="page-workspace-settings"]{display:block}', '', function(opts) {
    this.preload = async ({req, res}) => {
      await app.store.setup({
        workspace_id: req.params.workspace_id,
      });

      if (app.store.workspace_user.data.role === 'guest') {
        throw { status: 403 };
      }
    };

    this.head = () => {
      if (this.workspace) {
        return {
          title: `ワークスペース編集 | ${spat.config.head.ogp.site_name}`,
        };
      }
    };

    this.on('show', ({req, res}) => {

      this.workspaceUser = app.store.getWorkspaceUser();
      this.workspace = this.workspaceUser.relation.workspace;

      this.current = req.params.tab || 'overview';
      spat.updateMeta();
      this.update();
    });

    this.onChangeTab = (e) => {
      this.current = e.item.tab.id;

      spat.router.replace(`/workspaces/${this.workspace.id}/settings/${this.current}`);
      this.update();
    };

    this.on('updatedata', async () => {

      await this.workspace.refresh();
      this.update();
    });

});
riot.tag2('module-workspace-overview_', '<div class="fs16 bold lh15 mb24">概要</div> <form class="mb40" onsubmit="{submit}"> <div class="mb16"> <label> <div class="f fm mb24"> <div class="flex-fixed s80 rounded-20 overflow-hidden mr24"> <div class="s-full" ref="icon" data-is="atom-input-image" riot-src="{opts.workspace.data.icon_image.url}" icon-size="48"></div> </div> <div class="w-full"> <div class="fs13 lh15 bold mb21">ワークスペース名</div> <input class="input large light_secondary w-full" ref="name" placeholder="{app.data.placeholder.display_name}" required riot-value="{opts.workspace.data.name}"> </div> </div> </label> </div> <button class="button primary transition w220">更新</button> </form> <div if="{opts.workspace_user.data.role === &quot;admin&quot;}"> <div class="fs13 lh15 bold mb21">ワークスペースの削除</div> <button class="button accent_fill transition py6" onclick="{onDeleteWorkspace}">ワークスペースを削除</button> </div>', 'module-workspace-overview_,[data-is="module-workspace-overview_"]{display:block} module-workspace-overview_ input::placeholder,[data-is="module-workspace-overview_"] input::placeholder{color:rgba(29,40,76,0.2)} module-workspace-overview_ input:focus,[data-is="module-workspace-overview_"] input:focus{outline:none}', '', function(opts) {
    this.submit = async (e) => {
      e.preventDefault();

      let i = spat.modal.indicator();

      let data = {
        name: this.refs.name.value.trim(),
      };

      let url = await this.refs.icon.uploadAndGetImageURL();
      if (url) {
        data.icon_image = {
          url: url,
        };
      }

      await app.api.child(`workspaces/${this.opts.workspace.id}`).put(data);

      i.close();

      this.parent.trigger('updatedata');

      spat.modal.alert('完了しました！');

    };

    this.onDeleteWorkspace = () => {
      spat.modal.open('modal-workspace-delete', {workspace: this.opts.workspace});
    };

});
riot.tag2('module-workspace-users_', '<div class="lh15 fs16 bold mb29">ユーザー管理</div> <div class="lh15 fs13 bold mb21">ユーザー一覧</div> <div class="h16vh border rounded-8 overflow-scroll mb40"> <div class="relative f fm fbw px8 py4 hover-trigger hover-bg-pale cursor-pointer" each="{item in workspacesUsers}" onclick="{onOpenPopupUser}"> <div data-is="item-user" item="{item.relation.user}"></div> <div class="f fm"> <div class="f fm rounded-4 text-center cursor-pointer mr4 {app.utils.getRoleClass(item.data.role)}" onclick="{onOpenActionSheet}"> <div class="min-width-45 pr2 pl6 text-white fs10 bold font-lato">{item.data.role}</div><i class="icon-arrow-down pr4 text-background_light_secondary fs12 mt2"></i> </div> <div class="s16"><i class="icon-close fs16 text-background_dark_primary cursor-pointer hover-show tooltip" aria-label="{item.relation.user.data.screen_name}を削除" data-tooltip-position="right" onclick="{onDeleteUser}"></i></div> </div> </div> </div> <div class="fs13 bold text-label_dark_primary mb21">ユーザーの招待</div> <div class="mb16" data-is="atom-button-invite" role="member" workspace="{opts.workspace}" text="メンバー" description="メンバーに関する説明が入ります。メンバーに関する説明が入ります。メンバーに関する説明が入ります。メンバーに関する説明が入ります。"></div> <div class="mb40" data-is="atom-button-invite" role="guest" workspace="{opts.workspace}" text="ゲスト" description="ゲストに関する説明が入ります。ゲストに関する説明が入ります。ゲストに関する説明が入ります。ゲストに関する説明が入ります。"></div> <div class="lh15 fs13 bold mb21">招待中のユーザー</div> <div class="h16vh border rounded-8 overflow-scroll mb40"> <div class="px8 py10 hover-trigger hover-bg-pale" each="{item in invitedUsers}" data-is="item-invite-user_" item="{item}"></div> </div> <div class="f"> <div class="f fm cursor-pointer" onclick="{onCopyLink}"><i class="icon-copy text-primary fs24 mr8"></i> <div class="fs13 bold text-primary">招待リンクをコピー</div> </div> </div>', 'module-workspace-users_,[data-is="module-workspace-users_"]{display:block}', '', function(opts) {
    this.on('mount', async () => {
      let promises = [
        app.store.workspace.fetchWorkspaceUsers(),
        this.fetchInvitedUsers()
      ];
      [this.workspacesUsers, this.invitedUsers] = await Promise.all(promises);
      this.update();

      this.tags['atom-button-invite'].forEach(tag => {
        tag.on('submit', async () => {
          this.invitedUsers = await this.fetchInvitedUsers();
          this.update();
        });
      });
    });

    this.onOpenPopupUser = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      spat.popup.open('popup-user', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        position: 'bottom',
        offsetLeft: 32,
        offsetTop: -4,
        align: {x: 'left'},
        opts: {
          user: e.item.item.relation.user,
        },
      });
    };

    this.on('invitationcancel', async (e) => {
      await app.api.child(`invites/${e.item.item.id}`).del({
        workspace_id: app.store.getWorkspaceUser().data.workspace_id,
      });

      app.utils.openToast('cancelInvitation');
      this.invitedUsers = await this.fetchInvitedUsers();
      this.update();
    });

    this.fetchInvitedUsers = async () => {
      let {invites} = await app.api.child('invites').get({
        workspace_id: app.store.getWorkspaceUser().data.workspace_id,
        limit: 999,
      });
      return invites;
    };

    this.onCopyLink = () => {
      let url = 'ここにはurlが入ってきます。';
      app.utils.copyToClipBoard(url);
      app.utils.openToast('copy');
    };

    this.onDeleteUser = async (e) => {
      e.stopPropagation();
      let result = await spat.modal.confirm(`<b>${e.item.item.relation.user.data.display_name}</b>を削除しますか？\n新しい招待で再び参加させることができます。`,'', {
        positive: '削除',
      });
      if (!result) return;

      let _indicator = spat.modal.indicator();

      try {
        await app.store.workspace.excludeUser(e.item.item.data.user_id);
        this.workspacesUsers = await app.store.workspace.fetchWorkspaceUsers();
      }
      catch(err) {
        console.err(err.message);
        spat.modal.alert(err.message);
      }
      finally {
        _indicator.close();
      }
      app.utils.openToast('deleteUser');
      this.update();
    };

    this.onOpenActionSheet = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.popup) {
        this.popup = null;
        return;
      }

      let options = app.utils.roles.map((role) => {
        return {
          label: role,
          action: () => { popup.close(); this.updateRole(e, role); },
        };
      });

      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 4,
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.updateRole = async (e, role) => {

      if (e.item.item.data.role !== role) {
        await app.store.workspace.updateUser(e.item.item.data.user_id, {role});
        this.workspacesUsers = await app.store.workspace.fetchWorkspaceUsers();
        this.update();
      }
    };

});
riot.tag2('module-workspace-groups_', '<div class="s-full"> <div class="fs16 bold mb29">グループ管理</div> <button class="button base_light_dashed relative f fh h48 w-full hover-trigger transition cursor-pointer mb8" onclick="{onCreateGroup}"> <div class="hover-text-primary fs13 bold">グループを追加</div> <div class="absolute r16 t0 b0 f fm"><i class="hover-text-primary icon-add fs16"></i></div> </button> <div class="f fbw fm max-width-576 w-full h48 rounded-8 border border-separator_opacity pl16 pr8 mb8 mb0-last" each="{item, index in items}"> <div class="line-clamp-1 word-break-all fs13 bold mr16">@{item.data.screen_name}</div> <div class="f fm"> <div class="f w100 h20 mr10 overflow-x-scroll scrollbar-none {item.data.user_ids.length &gt; DISPLAY_RANGE ? &quot;&quot; : &quot;fr&quot;}"> <div class="circle s20 flex-fixed overflow-hidden border border-white bg-white" each="{user in displayUsers[index]}"><img class="s-full object-fit-cover cursor-pointer" riot-src="{user.relation.user.data.icon_image.url}" onclick="{onOpenPopupUser}"></div> </div> <div class="word-break-keep mr8" ref="group" onmouseenter="{showTooltipUsers}"><span class="bold fs13 mr2">{item.data.user_ids.length}</span><span class="fs10">人</span></div> <div class="p8 rounded-8 transition hover-trigger hover-bg-separator_opacity text-label_dark_medium cursor-pointer tooltip" onclick="{onEditGroup}" aria-label="編集" data-tooltip-position="top"><i class="icon-edit fs16"></i></div> </div> </div> </div>', 'module-workspace-groups_,[data-is="module-workspace-groups_"]{display:block}', '', function(opts) {
    this.DISPLAY_RANGE = 5;

    this.on('mount', () => {

      Promise.all([this.fetchGroups(), this.fetchUsers()]);
    });

    this.fetchGroups = async () => {
      this.items = await app.store.workspace.fetchGroups();
      this.items.sort((a, b) => {

        if (a.data.is_everyone) return 1;
        if (b.data.is_everyone) return -1;

        return a.data.screen_name > b.data.screen_name ? 1 : -1;
      });
      this.update();
    };

    this.fetchUsers = async () => {
      let workspaces_users = await app.store.workspace.fetchWorkspaceUsers();
      this.displayUsers = [];

      this.items.forEach((item) => {
        let filter_users = workspaces_users.filter(user => item.data.user_ids.includes(user.data.user_id));
        this.displayUsers.push(filter_users);
      });

      this.update();
    }

    this.onCreateGroup = async () => {
      let value = await spat.modal.open('modal-group', {
        other_groups: this.getOtherGroups()
      }).waitClose();
      if (value) {
        Promise.all([this.fetchGroups(), this.fetchUsers()]);
      }
    };

    this.onEditGroup = async (e) => {
      let selected_group = e.item.item;
      let value = await spat.modal.open('modal-group', {
        group: selected_group,
        other_groups: this.getOtherGroups(selected_group),
      }).waitClose();
      if (value) {
        Promise.all([this.fetchGroups(), this.fetchUsers()]);
      }
    };

    this.getOtherGroups = (group) => {
      if (!group) return this.items;
      return this.items.filter(item => {
        return item.data.screen_name !== group.data.screen_name;
      });
    };

    this.showTooltipUsers = async (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      let users = this.displayUsers[e.item.index].map(user => user.relation.user);
      spat.tooltip.open('tooltip-users', {
        element: this.refs.group[e.item.index],
        offsetLeft: 8,
        position: "right",
        opts: {
          users,
        },
      });
    };

    this.onOpenPopupUser = (e) => {
      e.preventDefault();
      e.stopPropagation();
      spat.popup.open('popup-user', {
        element: e.target,
        closeTarget: e.target,
        position: 'bottom',
        offsetLeft: 32,
        offsetTop: -4,
        opts: {
          user: e.item.user.relation.user,
        },
      });
    };

});
riot.tag2('item-invite-user_', '<div class="f fm fbw"> <div class="f fm w-full"> <div class="lh15 bold fs13 line-clamp-1 word-break-all mr8">{opts.item.email}</div><i class="icon-attention text-alert_primary tooltip" if="{isInvitingExpired()}" aria-label="招待の期限が切れています。三点リーダーより再招待してください。" data-tooltip-position="top"></i> </div> <div class="flex-fixed mr4" data-is="atom-role" role="{opts.item.role}"></div> <div class="s16 flex-fixed cursor-pointer tooltip" onclick="{openActionSheet}" aria-label="編集" data-tooltip-position="top"><i class="icon-more_horizontal hover-show fs16"></i></div> </div>', '', '', function(opts) {

    this.openActionSheet = (e) => {

      let options = [
        { label: '再招待', icon: 'close_mail', action: () => { popup.close(); this.resend(e); } },
        { label: '取り消す', icon: 'stash_box', action: () => { popup.close(); this.cancelInvitation(e); }, accent: true },
      ];
      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 4,
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.isInvitingExpired = () => {
      return dayjs().isAfter(this.opts.item.expired_at);
    };

    this.resend = async (e) => {
      await app.api.child(`invites/${e.item.item.id}/resend`).put({
        workspace_id: app.store.getWorkspaceUser().data.workspace_id,
      });

      app.utils.openToast('resendInvitation');
    };

    this.cancelInvitation = (e) => {
      this.parent.trigger('invitationcancel', e);
    };

});
riot.tag2('module-workspace-archived_', '<div class="s-full"> <div class="fs16 bold mb29">アーカイブ一覧</div> <div class="f fh py40" if="{loading}"> <div class="s50" data-is="atom-loading"></div> </div> <div if="{!loading}"> <div class="f fh py40 text-label_dark_medium fs13" if="{!items || items.length === 0}">アーカイブされたプロジェクトはありません</div> <div class="border rounded-8 overflow-scroll" if="{items &amp;&amp; items.length &gt; 0}" style="max-height: 60vh;"><a class="f fm flex-wrap fbw px16 py12 border-bottom border-bottom-last-none hover-trigger hover-bg-pale cursor-pointer" each="{item in items}" href="/{item.data.project_ref.path}"> <div class="flex-auto mr16" style="min-width: 0;"> <div class="fs13 bold line-clamp-1 word-break-all {item.data.project_name?.trim() ? &quot;&quot; : &quot;text-label_dark_medium&quot;}">{item.data.project_name?.trim() || \'（名前なし）\'}</div> </div> <div class="flex-fixed"> <button class="button small base_light transition cursor-pointer" onclick="{onUnarchive}">アーカイブを解除</button> </div></a></div> </div> </div>', 'module-workspace-archived_,[data-is="module-workspace-archived_"]{display:block}', '', function(opts) {
    this.loading = true;
    this.items = [];

    this.on('mount', async () => {
      await this.fetchArchivedProjects();
      this.loading = false;
      this.update();
    });

    this.fetchArchivedProjects = async () => {
      let uid = firebase.auth().currentUser.uid;
      this.items = await this.opts.workspace.collection('projects_users')
        .where('archived', '==', true)
        .where('user_id', '==', uid)
        .orderBy('project_name')
        .fetch({ relation: true });
    };

    this.onUnarchive = async (e) => {

      e.preventDefault();
      let project = e.item.item.relation.project;
      let result = await spat.modal.confirm('このプロジェクトのアーカイブを解除しますか?');
      if (!result) return;

      let _indicator = spat.modal.indicator();
      try {
        await project.unarchive();

        await project.refresh();
        await this.fetchArchivedProjects();
        this.update();
        app.utils.openToast('releaseProject');
      } finally {
        _indicator.close();
      }
    };
});